import React from 'react'
import FilterPage from '../Filter/FilterPage'
import SelectionPageContainer from '../Selection/SelectionPageContainer'
import HelpPage from '../Help/HelpPage'
import StompunktPageContainer from '../Stompunkt/StompunktPageContainer'
import ExportPage from '../Export/ExportPage'
import * as pages from '../../constants/pages'

export default ({ page }) => {
	switch (page) {
		case pages.FILTER:
			return <FilterPage />
		case pages.SELECTION:
			return <SelectionPageContainer />
		case pages.HELP:
			return <HelpPage />
		case pages.STOMPUNKT:
			return <StompunktPageContainer />
		case pages.EXPORT:
			return <ExportPage />
		case undefined:
			return null
		default:
			throw new Error("Okänd sida: " + page)
	}
}



// WEBPACK FOOTER //
// ./src/components/Layout/CurrentPage.js